export const calculateProfitMargin = (
    purchasePrice: number,
    sellingPrice: number,
) => {
    if (purchasePrice === 0) {
        return 0; // Avoid division by zero
    }
    const profit = sellingPrice - purchasePrice;
    const profitMargin = (profit / sellingPrice) * 100;
    return profitMargin.toFixed(2); // Return as percentage with 2 decimal places
};
